define.alias("checkout/components/payment/address", "calendar/components/payment/address");